import facebookLogo from '~/assets/images/auth/facebook_logo.svg';

/**
 * Facebook logo icon component used in social authentication buttons.
 *
 * This component renders the official Facebook/Meta logo as an SVG image. It is primarily
 * used by the SocialLoginButton component to display the Facebook branding when users
 * authenticate via Facebook Login. The icon follows Meta's official branding guidelines
 * to ensure compliance with their design standards.
 *
 * **Usage Context:**
 * - Displayed within SocialLoginButton when provider is set to 'facebook'
 * - Can be used standalone in other contexts requiring Facebook branding
 * - Automatically sized to 24x24px by default
 * - Marked as decorative (aria-hidden) for accessibility
 *
 * @param props - Component props
 * @param props.className - Optional CSS class names to apply custom styling (e.g., sizing, colors).
 *                          Use Tailwind utilities like "h-6 w-6" to override default dimensions.
 *
 * @example
 * ```tsx
 * <FacebookIcon className="h-6 w-6" />
 * ```
 *
 * @see {@link SocialLoginButton} - Parent component that uses this icon
 * @see https://www.meta.com/brand/resources/facebook/logo/ - Official Facebook branding guidelines
 */
export function FacebookIcon({ className }: { className?: string }) {
  return (
    <img
      src={facebookLogo}
      alt=""
      className={className}
      width="24"
      height="24"
      aria-hidden="true"
    />
  );
}
